<select #comboBox
  [(ngModel)]="selectedConvDiv" [disabled]="disabled" [hidden]="!visible" [class.combo-box-required]="required"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex" (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [autofocus]="autofocus">
  <ng-template ngFor let-item [ngForOf]="model.convDivList">
    <option value="{{item.ConvDiv}}">{{item.ConvDivName}}</option>
  </ng-template>
</select>
